import { render } from "./ShelfList.vue?vue&type=template&id=ddbe57a4&scoped=true"
import script from "./ShelfList.vue?vue&type=script&lang=js"
export * from "./ShelfList.vue?vue&type=script&lang=js"

import "./ShelfList.vue?vue&type=style&index=0&id=ddbe57a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbe57a4"]])

export default __exports__